import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "input", "selection", "selectedName", "organizationId"]

  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  search() {
    if (this.timeout) clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      const query = this.inputTarget.value.trim()
      if (query.length >= 2) {
        this.formTarget.requestSubmit()
      }
    }, 300)
  }

  select({ params: { id, name } }) {
    this.organizationIdTarget.value = id
    this.selectedNameTarget.textContent = name
    this.selectionTarget.classList.remove("hidden")
  }

  clear() {
    this.organizationIdTarget.value = ""
    this.selectedNameTarget.textContent = ""
    this.selectionTarget.classList.add("hidden")
  }
}
